
<template>
    <div>
        <el-form :modal="form" label-width="120px" :loading="loading">

            <!-- 主机名 -->
            <el-row>
                <el-col>
                    <el-form-item label="主机名:">
                        <span>{{form.hostname}}</span>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- salt_id -->
            <el-row>
                <el-col>
                    <el-form-item label="salt_id:">
                        <span>{{form.salt_id}}</span>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 端口 -->
            <el-row>
                <el-col>
                    <el-form-item label="端口:">
                        <span>{{form.ssh_port}}</span>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 协议 -->
            <el-row>
                <el-col>
                    <el-form-item label="协议:">
                        <span>ssh</span>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 内存 -->
            <el-row>
                <el-col>
                    <el-form-item label="内存:">
                        <span>{{(form.mem_total/1024).toFixed(2)}}M</span>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 虚拟化 -->
            <el-row>
                <el-col>
                    <el-form-item label="虚拟化:">
                        <span>{{form.virtual}}</span>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- IP -->
            <el-row>
                <el-col>
                    <el-form-item label="IP:">
                        <template>
                            <el-table :data="form.ip4_interfaces" border style='width:500px'>
                                <el-table-column prop="key" label='属性名' align='center' width='150' />
                                <el-table-column prop="value" label='属性值' align='center' />
                            </el-table>
                        </template>
                        <!-- <span>{{form.ip4_interfaces}}</span> -->
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- CPU -->
            <el-row>
                <el-col>
                    <el-form-item label="CPU:">
                        <template>
                            <el-table :data="form.cpu" border style='width:500px'>
                                <el-table-column prop="key" label='属性名' align='center' width='150' />
                                <el-table-column prop="value" label='属性值' align='center' />
                            </el-table>
                        </template>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 硬盘 -->
            <el-row>
                <el-col>
                    <el-form-item label="硬盘:">
                        <template>
                            <el-table :data="form.disk" border>
                                <el-table-column prop="path" label='路劲' align='center' />
                                <el-table-column prop="1K - blocks" label='大小' align='center' />
                                <el-table-column prop="used" label="已使用" align='center' >
                                    <template slot-scope='scope'>
                                        <span>{{(scope.row.used/1024/1024).toFixed(2)}}G</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="available" label="还剩" align='center' />
                                <el-table-column prop="1K-blocks" label="1K-blocks" align='center' />
                                <el-table-column prop="filesystem" label="设备" align='center' />

                                <el-table-column prop="capacity" label="利用率" align='center' />
                            </el-table>
                        </template>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 内核 -->
            <el-row>
                <el-col>
                    <el-form-item label="内核:">
                        <template>
                            <el-table :data="form.kernel" border style='width:600px'>
                                <el-table-column prop="key" label='属性名' align='center' width='150' />
                                <el-table-column prop="value" label='属性值' align='center' />
                            </el-table>
                        </template>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 系统OS -->
            <el-row>
                <el-col>
                    <el-form-item label="系统OS:">
                        <template>
                            <el-table :data="form.os" border style='width:400px'>
                                <el-table-column prop="key" label='属性名' align='center' width='150' />
                                <el-table-column prop="value" label='属性值' align='center' />
                            </el-table>
                        </template>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 主板 -->
            <el-row>
                <el-col>
                    <el-form-item label="主板:">
                        <template>
                            <el-table :data="form.motherboard" border style='width:600px'>
                                <el-table-column prop="key" label='属性名' align='center' width='150' />
                                <el-table-column prop="value" label='属性值' align='center' />
                            </el-table>
                        </template>
                    </el-form-item>
                </el-col>
            </el-row>

        </el-form>
    </div>
</template>


<script>
    import services from './common.services'
    export default {
        data() {
            return {
                form: {},
                loading: true
            }

        },

        computed: {
            hostId() {
                return this.$route.query.host_id
            }
        },

        mounted() {
            this.getDetail()
        },

        methods: {
            getDetail() {
                services.host_describe(this.hostId)
                    .then(res => this.form = {
                            ...res.child,
                            hostname: res.hostname,
                            salt_id: res.salt_id
                        }
                    )
                    .catch(err => this.$message.error(err.message))
                    .finally(() => this.loading = false)
            }
        }

    }
</script>

